// The date-format tokens the renderer's formatters accept, mirroring the
// ChoiceBlock choices on the Wagtail chart blocks. Pickers must build their
// <option> lists from these: a token that exists only in a picker serialises
// into the chart block, falls through every formatter's default branch, and
// silently disables formatting.
export const DATE_FORMATTING_OPTIONS = [
    { value: 'none', label: 'None' },
    { value: 'date', label: 'Date' },
    { value: 'year', label: 'Year' },
    { value: 'monthyear', label: 'Month-Year' },
    { value: 'monthday', label: 'Month-Day' },
    { value: 'datetime', label: 'DateTime' },
];

// Timeline dates additionally offer the readable form (e.g. Jan 1, 2024).
export const TIMELINE_DATE_FORMATTING_OPTIONS = [
    { value: 'none', label: 'None' },
    { value: 'human-readable', label: 'Readable Date' },
    { value: 'date', label: 'Date' },
    { value: 'year', label: 'Year' },
    { value: 'monthyear', label: 'Month-Year' },
    { value: 'monthday', label: 'Month-Day' },
    { value: 'datetime', label: 'DateTime' },
];
